import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard  {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (sessionStorage.getItem('currentUser')) {
        //this.router.navigate(['/kunden']);
       
              // window.location.href = '/kunden';
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
       window.location.href = '/login';
        // this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        return false;
    }
}
